import React, { Component } from 'react'
import { Table } from 'reactstrap'
import parse from 'html-react-parser'
import './style.css';
import ERROR_MESSAGES from './ErrorMessages';

export class Receipt extends Component {

    constructor(props) {
        super(props);

        const search = props.location.search;
        const params = new URLSearchParams(search);
        this.state = {
            paymentResponse: this.paramsToObject(params),
            apiResponse: null,
            isAPIresponse: false,
            isAPIError: false
        }
        this.updatePaymntDetails = this.updatePaymntDetails.bind(this);
    }

    componentDidMount() {
        this.updatePaymntDetails();
    }

    RedirectToLandingPage(e) {
        e.preventDefault();
        if (window.parent)
            window.top.location.href = "/";
        else
            window.location.href = "/";
    }

    paramsToObject(entries) {
        const result = {}
        for (const [key, value] of entries) { // each 'entry' is a [key, value] tupple
            result[key] = value;
        }
        return result;
    }

    updatePaymntDetails() {
        const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
        var url = API_BASE_URL + '/api/ESPcase';
        const data = this.state.paymentResponse;
        const requestOptions =
        {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                OrderId: data.ORDER_ID,
                Result: data.RESULT,
                Timestamp: data.TIMESTAMP,
                Message: data.MESSAGE,
                AuthCode: data.AUTHCODE,
                batchID: data.BATCHID,
                Parsref: data.PASREF,
                CaseNumber: data.CASE_NUMBER,
                Amount: data.AMOUNT,
                Sha1Hash: data.SHA1HASH
            })
        }
        fetch(url, requestOptions)
            .then(response => response.json())
            .then(apiData => {
                if (apiData.ResponseStatus === 200) {
                    this.setState({ apiResponse: apiData });
                    this.setState({ isAPIresponse: true });
                }
                else {
                    this.setState({ isAPIError: true });
                    this.setState({ isAPIresponse: true });
                }
            })
            .catch((err) => {
                this.setState({ isAPIError: true });
                this.setState({ isAPIresponse: true });
               
            });

        
    }

    render() {

        if (!this.state.isAPIresponse) {
            return (
                <div className="d-flex justify-content-center">
                    <div className="spinner-border" role="status">
                        <span className="sr-only">Loading...</span>
                    </div>
                </div>
            );
        }
        else if (this.state.isAPIError) {
            return (
                <div tabIndex="0" role="error">
                    <label> {parse(ERROR_MESSAGES.API_ERROR)}</label>
                </div>
            );
        }
        else {
            const isSuccess = this.state.paymentResponse.RESULT === "00";
            const date = this.state.apiResponse.Date;
            const time = this.state.apiResponse.Time;
            const amount = "EUR " + (this.state.paymentResponse.AMOUNT / 100).toFixed(2);
            const orderId = this.state.paymentResponse.ORDER_ID;
            const ReferenceNo = this.state.apiResponse.CaseMumbers ? this.state.apiResponse.CaseMumbers : this.state.paymentResponse.CASE_NUMBER ;
            const transactionRef = this.state.paymentResponse.MESSAGE;

            return (
                <div>
                    {isSuccess &&
                        <div className="col">

                            <div className="col text-center font-weight-bold" tabIndex="0" >
                                <label>RECEIPT OF PAYMENT</label>
                                <br />
                                <label> M50 BARRIER-FREE TOLLING SYSTEM</label>
                            </div>

                            <div className="row">
                                <div className="center">
                                    <Table borderless>
                                        <thead>
                                            <tr>
                                                <td className="font-weight-bold" tabIndex="0" >
                                                    PAYMENT RECEIPT
                                                </td>
                                                <td>
                                                </td>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td className="font-weight-bold" tabIndex="0" aria-label="receipt Date">
                                                    Date:
                                                </td>
                                                <td tabIndex="0" >
                                                    {date}
                                                </td>
                                            </tr>
                                            <tr>
                                                <td className="font-weight-bold" tabIndex="0" aria-label="Payment Receipt Number">
                                                    Payment Receipt No:
                                                </td>
                                                <td tabIndex="0" >
                                                    {orderId}
                                                </td>
                                            </tr>
                                            <tr>
                                                <td className="font-weight-bold" tabIndex="0" >
                                                    Amount Paid:
                                                </td>
                                                <td tabIndex="0" >
                                                    {amount}
                                                </td>
                                            </tr>
                                            <tr>
                                                <td className="font-weight-bold" tabIndex="0" aria-label="Reference Number">
                                                    Reference No:
                                                </td>
                                                <td tabIndex="0" >
                                                    {ReferenceNo}
                                                </td>
                                            </tr>
                                            <tr>
                                                <td className="font-weight-bold" tabIndex="0" >
                                                    Transaction Result:
                                                </td>
                                                <td tabIndex="0" >
                                                    {transactionRef}
                                                </td>
                                            </tr>
                                        </tbody>
                                    </Table>
                                </div>
                                <div className="col text-center" tabIndex="0" >
                                    Please  print a copy of this as evidence
                                    of payment.
                                </div>
                            </div>

                            <div className="row section" role="Note">
                                <label tabIndex="0">
                                    Kindly note that www.pierfitz.ie/eflow will appear on your bank statement in respect of this payment.<br />
                                    <i>Beidh an seoladh www.pierfitz.ie/eflow le feiceail ar do raiteas bainc i leith an iocaiocht seo</i>
                                </label>
                            </div>
                        </div>
                    }
                    {!isSuccess &&
                        <div >
                            <div className="col" tabIndex="0" >
                                <label>Transaction failed. There has been a problem processing your transaction. Please contact your card provider.</label>

                            </div>

                            <div className="center">
                                <Table borderless>
                                    <tbody>
                                        <tr>
                                            <td className="font-weight-bold" tabIndex="0" >
                                                Pierfitz Reference:
                                            </td>
                                            <td tabIndex="0" >
                                                {orderId}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className="font-weight-bold" tabIndex="0" aria-label="receipt Date" >
                                                Date:
                                            </td>
                                            <td tabIndex="0" >
                                                {date}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className="font-weight-bold" tabIndex="0" aria-label="receipt time" >
                                                Time:
                                            </td>
                                            <td tabIndex="0" >
                                                {time}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className="font-weight-bold" tabIndex="0" >
                                                Transaction Result:
                                            </td>
                                            <td tabIndex="0" >
                                                {transactionRef}
                                            </td>
                                        </tr>
                                    </tbody>
                                </Table>
                            </div>

                            <div className="col section text-center">
                                <button className="btn btn-secondary" aria-label="Return Button" onClick={this.RedirectToLandingPage}>Return</button>
                                <br />
                                <span className="font-weight-bold font-italic" tabIndex="0">filleadh</span>
                            </div>

                        </div>
                    }

                </div>
            );
        }
    }
}